import {
  Box,
  Button,
  CircularProgress,
  Container,
  Paper
} from '@mui/material'
import React from 'react'
import { useStyles } from '../Position/screens/styles'
import { usePosition } from '../Position/context'
import { excelIcon } from '../../images/excelIcon'
// ICONS
import AddCircleIcon from '@mui/icons-material/AddCircle'
import EditIcon from '@mui/icons-material/Edit'

interface ControlsSelectorProps {
  handleOpenPositionMassive: (param: boolean) => void
  fetchExportData: () => void
}

export const ControlsButtonsMasiv: React.FC<ControlsSelectorProps> = ({
  handleOpenPositionMassive,
  fetchExportData
}) => {
  const classes = useStyles()

  const { state } = usePosition()
  const { rows, loadingExport } = state

  return (
    <Container maxWidth='xl'>
      <Paper elevation={5}>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            padding: '20px'
          }}
        >
          <Box className={classes.buttonBar}>
            <Box marginRight={2}>
              <Button
                variant='contained'
                color='primary'
                startIcon={<AddCircleIcon />}
                onClick={() => {
                  handleOpenPositionMassive(false)
                }}
              >
                Crear posiciones masivas
              </Button>
            </Box>
            <Box marginRight={2}>
              <Button
                variant='contained'
                color='primary'
                startIcon={<EditIcon />}
                onClick={() => {
                  handleOpenPositionMassive(true)
                }}
              >
                Editar posiciones masivas
              </Button>
            </Box>

            <Button
              variant='contained'
              color='primary'
              onClick={() => {
                fetchExportData()
              }}
              startIcon={
                loadingExport ? (
                  <CircularProgress size='0.9rem' />
                ) : (
                  <img
                    src={excelIcon}
                    alt='excelIcon'
                    style={{
                      width: '16px',
                      height: '16px',
                      maxWidth: '16px',
                      minWidth: '16px',
                      filter: 'invert(100%)'
                    }}
                  />
                )
              }
              disabled={!rows.length || loadingExport}
            >
              Exportar posiciones masivas
            </Button>
          </Box>
        </Box>
      </Paper>
    </Container>
  )
}
